export default __webpack_public_path__ + "static/media/013-no alarm.c6732ce5.png";